module.exports = __webpack_public_path__ + "img/tg_01 (8).ce6bd80f.jpg";